<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display add-map-layout-dialog custom-dialog customerEDIInfo"
    :style="$cookies.get('comp-id') === $cookies.get('ownr-id') ? 'width: 900px !important;' : ''"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text pa-4" primary-title>{{
        options.item.action == 'add' ? 'Add ' + title : 'Modify ' + title
      }}</v-card-title>
    </template>
    <template v-slot:button-close>
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-card class="v-dialog-1 dialog-company-Detail add-map-layout-dialog">
      <v-row>
        <system-progress
          :sysloading="isLoading"
          :sysloadingTitle="sysloadingTitle"
        ></system-progress>
        <v-col cols="7" class="pb-0 pl-6">
          <v-label>{{ $t('lbl.company.companyInfo') }}</v-label>
        </v-col>
        <v-col cols="5" class="pl-6 pb-0">
          <v-label>{{ $t('lbl.identification.ediInfo') }}</v-label>
        </v-col>
      </v-row>
      <v-card-text class="pa-0">
        <v-row>
          <v-col cols="7">
            <v-form ref="form" class="dialog-content form-identification form-company">
              <v-row class="ml-0 mr-0 mb-1">
                <v-col cols="12" class="pa-0">
                  <v-label
                    ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                    >{{ $t('lbl.company.companyId') }}</v-label
                  >
                  <v-text-field
                    ref="compId"
                    v-model="editedItem.data[0].compId"
                    :rules="[
                      validationUtils.required,
                      validationUtils.emailIdRules,
                      validationUtils.max(50),
                    ]"
                    :error="dupErr"
                    :error-messages="dupErrMsg"
                    @input="clearDupErr()"
                    heigth="30"
                    solo
                    class="text-field-company"
                    :readonly="!!editedItem.data[0].id"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ml-0 mr-0 mb-1">
                <v-col cols="12" class="pa-0">
                  <v-label
                    ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                    >{{ $t('lbl.company.companyName') }}</v-label
                  >
                  <v-text-field
                    ref="compNm"
                    v-model="editedItem.data[0].compNm"
                    :rules="rules.compNm"
                    heigth="30"
                    solo
                    class="text-field-company"
                    autofocus
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ml-0 mr-0 mb-1">
                <v-col cols="12" class="pa-0">
                  <v-label
                    ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                    >{{ $t('lbl.company.contactPerson') }}</v-label
                  >
                  <v-text-field
                    ref="cnttPrn"
                    v-model="editedItem.data[0].cnttPrn"
                    :rules="rules.cnttPrn"
                    heigth="30"
                    solo
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ml-0 mr-0 mb-1">
                <v-col cols="12" class="pa-0">
                  <v-row class="ma-0 check-row-partner">
                    <v-label>{{ $t('lbl.company.emailAddress') }}</v-label>
                  </v-row>
                  <v-row class="ma-0">
                    <!-- <v-col cols="6" class="map-text-field pa-0">
                      <v-text-field
                        ref="emailF"
                        v-model="editedItem.data[0].emailF"
                        :rules="rules.emailF"
                        heigth="30"
                        solo
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" class="map-text-field inline-block-company pa-0">
                      <div class="mr-3 ml-3 pt-2">
                        <span class="field-label">
                          @
                        </span>
                      </div>
                      <v-text-field
                        ref="emailT"
                        v-model="editedItem.data[0].emailT"
                        heigth="30"
                        :rules="rules.emailT"
                        :disabled="editedItem.data[0].id ? true : false"
                        solo
                        :error="dupErr"
                        :error-messages="dupErrMsg"
                        @input="clearDupErr()"
                      ></v-text-field>
                    </v-col> -->
                    <v-col cols="12" class="map-text-field inline-block-component pa-0">
                      <v-text-field
                        ref="email"
                        v-model="editedItem.data[0].email"
                        :rules="[validationUtils.emailRules]"
                        :maxlength="50"
                        :readonly="!!editedItem.data[0].id"
                        @input="setCheckStatus()"
                        heigth="30"
                        solo
                      ></v-text-field>
                      <v-btn
                        class="ml-3 check-btn-partner"
                        :color="checkBtnColor"
                        @click="checkEmailCompany()"
                        v-if="!editedItem.data[0].id"
                      >
                        <v-icon x-small>{{ checkBtnIcon }}</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="ml-0 mr-0">
                <v-col cols="12" class="pa-0">
                  <v-label>{{ $t('lbl.identification.remark') }}</v-label>
                  <v-textarea
                    ref="remark"
                    v-model="editedItem.data[0].remark"
                    counter="200"
                    solo
                    height="60"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row class="ml-0 mr-0 mb-1" v-if="Number($cookies.get('use-grade')) === 9">
                <v-col cols="6" class="pl-1 pa-0">
                  <v-checkbox
                    v-model="editedItem.data[0].spFlg"
                    ref="spFlg"
                    label="Company Management"
                    dense
                  ></v-checkbox>
                </v-col>
                <v-col cols="6" class="pl-1 pa-0">
                  <v-checkbox
                    v-model="editedItem.data[0].compRepoUseFlg"
                    ref="compRepoUseFlg"
                    label="Use DLB Functions"
                    dense
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
          <!-- /*
          * 2021.20.07 203737 SPKA-159 issue 107 Add "Character Set" Item 
          */ -->
          <v-col cols="5" class="pl-1">
            <v-row class="ml-0 mb-6">
              <v-col cols="12">
                <v-form
                  ref="formEDI"
                  class="dialog-content form-identification edi-iden-company-list pr-0 pb-4"
                >
                  <v-row class="ml-0 mr-0">
                    <v-col lg="6" class="pa-0">
                      <v-label>{{ $t('lbl.identification.ediID') }}</v-label>
                    </v-col>
                    <v-col lg="4" class="pa-0 ml-2">
                      <v-label>{{ $t('lbl.identification.qualifier') }}</v-label>
                    </v-col>
                    <v-col lg="1" class="pa-0 ml-3 mr-0">
                      <v-icon dense @click="addEDI()">
                        mdi-plus
                      </v-icon>
                    </v-col>
                  </v-row>
                  <v-row
                    class="ml-0 mr-0 mb-2 edi-identification custom-bg-input"
                    v-show="item.status != 'D'"
                    v-for="(item, index) in listEDI"
                    :key="item.id"
                  >
                    <v-col lg="6" class="pa-0">
                      <v-text-field
                        :ref="'EDI_' + item.id"
                        :maxlength="50"
                        solo
                        hide-details
                        v-model="item.srId"
                        :disabled="item.status != 'I'"
                        :readonly="item.status != 'I'"
                        :class="[item.status != 'I' ? 'custome-edi-not-allowed' : '']"
                      ></v-text-field>
                    </v-col>
                    <v-col lg="4" class="pa-0 ml-2">
                      <v-text-field
                        :ref="'EDI_' + item.id + '_' + item.id"
                        :maxlength="50"
                        solo
                        hide-details
                        v-model="item.srQlfr"
                        @change="changeEDI(item, index)"
                        :disabled="item.numOfUse > 0"
                        :readonly="item.numOfUse > 0"
                        :class="[item.numOfUse > 0 ? 'custome-edi-not-allowed' : '']"
                      ></v-text-field>
                    </v-col>
                    <v-col lg="1" class="pa-0 ml-3 mr-0 mt-2">
                      <v-tooltip top :disabled="item.numOfUse == 0">
                        <template v-slot:activator="{ on }">
                          <div v-on="on" class="btn-tooltip">
                            <v-icon
                              dense
                              @click="removeEDI(item, index)"
                              :disabled="item.numOfUse > 0"
                            >
                              mdi-minus
                            </v-icon>
                          </div>
                        </template>
                        <span v-html="$t('lbl.processSetup.ediInUseWF')"></span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
            </v-row>
            <v-row class="ml-0 mb-2">
              <v-col cols="12" class="pb-0">
                <v-label>{{ $t('lbl.common.characterSet') }}</v-label>
              </v-col>
            </v-row>
            <v-row class="ml-0">
              <v-col cols="12">
                <v-form ref="formEDI" class="dialog-content form-identification character-set pr-0">
                  <v-row class="ml-0 mr-0">
                    <v-col lg="12" class="pa-0">
                      <v-select
                        v-model="editedItem.data[0].chrSet"
                        class="custom-selectbox select-character-set"
                        :placeholder="$t('lbl.common.characterSet')"
                        :items="characterSetList"
                        height="30"
                        hide-details
                        dense
                        solo
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider class="ml-0 mr-0 mt-3 divder-popup" inset></v-divider>
        <v-row class="ml-0 mr-0 pt-2">
          <v-col class="button-col action-col character-set" lg="12">
            <div class="btn-form-control text-right">
              <v-btn class="btn btn-delete btn-popup" @click="removeDialog">{{
                $t('lbl.company.close')
              }}</v-btn>
              <v-btn
                class="btn btn-popup-search btn-popup"
                color="primary"
                @click="save()"
                :disabled="!$auth.manage"
                >{{ $t('lbl.company.save') }}</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup body-->
      <dialogWindow
        ref="warningDialog"
        size="max"
        title="Merge & Compare"
        :detail="checkDialogInfo"
        @select-ok="focusInvalid"
        :color="checkDialogColor"
      ></dialogWindow>
      <dialogWindow
        ref="companySaveDialog"
        size="max"
        :detail="checkDialogInfo"
        :color="checkDialogColor"
        @select-ok="removeDialogRefesh({})"
      >
      </dialogWindow>
    </v-card>
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag2.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { mapState } from 'vuex';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';

export default {
  components: {
    DialogDrag,
    dialogWindow,
    IconSvg,
    SystemProgress,
  },
  props: {
    id: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
  },
  computed: {
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
  },
  data() {
    return {
      editedItem: {
        data: [
          {
            compId: '',
            compNm: '',
            cnttPrn: '',
            email: '',
            // emailF: '',
            // emailT: '',
            remark: '',
            chrSet: '',
          },
        ],
      },
      detailDialog: false,
      value: {},
      checkResult: '',
      idFocus: '',
      rules: {
        compNm: [
          (v) => !!v || 'Company Name Address is required',
          (v) => !v || v.length <= 50 || 'Company Name max length is 50.',
        ],
        cnttPrn: [
          (v) => !!v || 'Contact Person is required',
          (v) => !v || v.length <= 100 || 'Contact Person max length is 100.',
        ],
        // emailF: [
        //   (v) => !!v || 'Company Email Local-part is required',
        //   (v) => !v || v.length <= 45 || 'Company Email ID max length is 45.',
        // ],
        // emailT: [
        //   (v) => !!v || 'Company Email Domain is required',
        //   (v) => !v || v.length <= 50 || 'Email Address max length is 50.',
        //   (v) => !v || /.+\..+/.test(v) || 'Company Email Domain must be valid',
        // ],
        remark: [(v) => !v || v.length <= 200 || 'Remark max length is 200.'],
      },
      isLoading: false,
      formHasErrors: false,
      dupErr: false,
      dupErrMsg: '',
      checkDialogInfo: '',
      checkDialogColor: 'success',
      listEDI: [],
      characterSetList: [],
      loadFormData: [],
      title: 'Company',
      checkBtnColor: 'secondary',
      checkBtnIcon: 'fa fa-question',
    };
  },
  methods: {
    checkEmailCompany() {
      if (this.editedItem.data[0].email.length > 0) {
        this.$store.dispatch('checkEmailCompany', this.editedItem.data[0]).then((res) => {
          if (!res) {
            this.setCheckStatus('S');
          } else {
            this.setCheckStatus('E');
          }
        });
      }
    },
    setCheckStatus(val) {
      if (val === 'S') {
        this.checkBtnColor = 'success';
        this.checkBtnIcon = 'fa fa-check';
      } else if (val === 'E') {
        this.checkBtnColor = 'error';
        this.checkBtnIcon = 'fa fa-times';
      } else {
        this.checkBtnColor = 'secondary';
        this.checkBtnIcon = 'fa fa-question';
      }
    },
    getInitData() {
      return {
        compId: '',
        compNm: '',
        cnttPrn: '',
        emailF: '',
        emailT: '',
        remark: '',
        chrSet: '',
      };
    },
    addEDI() {
      let index = this.listEDI.length > 0 ? this.listEDI[this.listEDI.length - 1].id + 1 : 1;
      // 2021.5.27 203728 SPKA-123 remove default ZZZ
      this.listEDI.push({ id: index, srId: '', srQlfr: '', status: 'I', numOfUse: 0 });
    },
    removeEDI(item, index) {
      if (item.status == 'I') {
        this.listEDI.splice(index, 1);
      } else {
        this.listEDI[index].status = 'D';
      }
    },
    // 2021.5.7 203728 Add update EDI
    changeEDI(item, index) {
      if (item.status != 'I') {
        this.listEDI[index].status = 'U';
      }
    },
    getEDIList() {
      // 2021.3.30 203728 Get EDI list
      this.$store
        .dispatch('getCompanyEdiListNew', { companyID: this.editedItem.data[0].compId })
        .then(() => {
          this.listEDI = [];
          if (this.$store.getters.compEdiIdList.length > 0) {
            this.$store.getters.compEdiIdList.map((e, i) => {
              this.listEDI.push({
                id: i + 1,
                srId: e.srId,
                srQlfr: e.srQlfr,
                status: e.status,
                numOfUse: e.numOfUse,
              });
            });
          }
        });
    },
    save() {
      try {
        let validResult = this.$refs.form.validate();
        if (validResult) {
          this.isLoading = true;
          let index = this.listEDI.find((e) => e.srId == '');
          if (index) {
            this.isLoading = false;
            return this.$refs[
              `EDI_${index.id}${index.srId == '' ? '' : '_' + index.id}`
            ][0].focus();
          }
          let arrChk = this.listEDI.map((e) => {
            return e.srId + e.srQlfr;
          });
          let isDuplicate = arrChk.findIndex((e, i) => {
            return arrChk.indexOf(e) != i;
          });

          if (isDuplicate > -1) {
            this.checkDialogInfo = 'EDI Identification is duplicate.';
            this.checkDialogColor = 'validation';
            this.isLoading = false;
            this.$refs.warningDialog.dialog = true;
            this.idFocus = `EDI_${isDuplicate + 1}`;
            return;
          }

          this.editedItem.data[0].edi_list = this.listEDI.filter((e) => e.status);
          this.editedItem.data[0].edi_list.map((e) => {
            e.srQlfr = e.srQlfr.trim();
          });

          if (this.editedIndex > -1) {
            this.$store
              .dispatch('updateCompanyFromProcSetup', this.editedItem.data[0])
              .then(() => {
                const companyId = this.$store.getters.companyId;
                this.checkDialogInfo = `${this.editedItem.data[0].compNm} has been updated successfully.`;
                let formEmit = {
                  type: 'COMP',
                  comId: companyId,
                };
                EventBus.$emit('refresh-list-component', formEmit);
                this.checkDialogColor = 'success';
                this.isLoading = false;
                this.$refs.companySaveDialog.dialog = true;
              })
              .catch((err) => {
                this.checkDialogInfo = `Exception occured updating ${this.editedItem.data[0].compNm} company info.\nReason: ${err}`;
                this.checkDialogColor = 'error';
                this.isLoading = false;
                this.$refs.warningDialog.dialog = true;
              });
          } else {
            this.$store.dispatch('checkCompany', this.editedItem.data[0]).then(() => {
              if (!this.$store.getters.duplicate.compId) {
                this.$store
                  .dispatch('insertCompany', this.editedItem.data[0])
                  .then(() => {
                    this.checkDialogInfo = `${this.editedItem.data[0].compNm} has been created successfully.`;
                    this.checkDialogColor = 'success';
                    this.isLoading = false;
                    this.$refs.companySaveDialog.dialog = true;
                  })
                  .catch((err) => {
                    this.checkDialogInfo = `Exception occured creating ${this.editedItem.data[0].compNm} company info.\nReason: ${err}`;
                    this.checkDialogColor = 'error';
                    this.isLoading = false;
                    this.$refs.warningDialog.dialog = true;
                  });
              } else {
                // alert('Duplicated company.');
                // this.$refs.emailT.error = true;
                this.dupErr = true;
                this.isLoading = false;
                this.dupErrMsg = `${this.editedItem.data[0].compNm} is already exist.`;
              }
            });
          }

          this.isLoading = false;
        }
      } catch (err) {
        this.checkDialogInfo = `Exception occured.\nReason: ${err}`;
        this.checkDialogColor = 'error';
        this.isLoading = false;
        this.$refs.warningDialog.dialog = true;
      }
    },
    focusInvalid() {
      if (this.idFocus) {
        let self = this;
        return setTimeout(() => {
          self.$refs[self.idFocus][0].focus();
        }, 300);
      }
    },
    removeDialogRefesh(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
      // 2021.5.17 203728 Auto choose new parnter
      let data = {};
      // if (this.companyId) data.prnrId = this.editedItem.data[0].emailT;
      this.$emit('search', data);
    },
    clearDupErr() {
      this.dupErr = false;
      this.dupErrMsg = '';
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    getCharacterSetList() {
      this.$store.dispatch('caascommon/getComCdList', { grpCd: 'C06' }).then(() => {
        let characterSetList = this.$store.getters['caascommon/comCdList'];
        characterSetList.map((item) => {
          this.characterSetList.push({ text: item.text, value: item.value });
        });
      });
    },
  },
  created() {
    if (this.options.item.title) {
      this.title = this.options.item.title;
    }
    if (this.options.item.action != 'add') {
      let data = this.options.item.data;
      this.editedItem.data[0] = Object.assign({}, data);
      // 2022.04.15 SPKA-440 add Internal Use check box
      this.editedItem.data[0].spFlg = data.spFlg === 'Y' ? true : false;
      this.editedItem.data[0].compRepoUseFlg = data.compRepoUseFlg === 'Y' ? true : false;
      console.log('modify', this.editedItem.data[0]);
      this.editedIndex = data.id;
      this.getEDIList();
      this.loadFormData = Object.assign({}, this.getInitData(), data);
    }
    this.getCharacterSetList();
  },
};
</script>
